const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isStaging = window.location.hostname.includes('staging') || window.location.hostname.includes('pages.dev');

// Determine the API base URL based on environment
const getApiBaseUrl = () => {
  if (isLocal) {
    // For local development, use the local Worker
    return "http://localhost:8787";
  } else if (isStaging) {
    // For staging, use the Cloudflare Worker
    return "https://api-staging.chrysalinks.co.za";
  } else {
    // For production, use the production Worker
    return "https://api.chrysalinks.co.za";
  }
};

// Sentry DSN - load from environment variable or use placeholder
// In production, set VITE_SENTRY_DSN environment variable
const sentryDsn = 'https://d9bd7531ae7bd4f6230d77a9643d74d2@o4511109680070656.ingest.us.sentry.io/4511110206455808';

const apiBase = getApiBaseUrl();

export const config = {
    // Identity & Roles
    ADMIN_EMAIL: "admin@chrysalinks.co.za",
    API_BASE_URL: apiBase,
    AUTH_API_URL: `${apiBase}/api/auth`,
    WS_URL: isLocal ? "ws://localhost:8787/ws" : "wss://api.chrysalinks.co.za/ws",

    // Persistence Keys
    USER_EMAIL_KEY: "USER_EMAIL",
    USER_ROLE_KEY: "USER_ROLE",

    // Security
    PROVISION_TOKEN: "your-secure-provision-token",
    SENTRY_DSN: sentryDsn,

    // User email (set at runtime by App.tsx)
    USER_EMAIL: "" as string,

    // AI Backend Configuration
    OLLAMA_BASE_URL: isLocal ? "http://localhost:11434" : "https://gestalt360-ollama.hf.space",
    HF_TOKEN: "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",
    // FreeLLMAPI proxy — OpenAI-compatible unified API
    // Base URL: http://localhost:3001/v1 (NOT the PWA dev server at :5173)
    // Chat: /v1/chat/completions, Responses: /v1/responses, Embeddings: /v1/embeddings
    // Providers: Google AI Studio, Groq, Cerebras, NVIDIA, Mistral, OpenRouter,
    //   GitHub Models, Cohere, Cloudflare Workers AI, Z.ai, Ollama Cloud, Kilo,
    //   Pollinations, OVH, LLM7, HuggingFace Router, OpenCode Zen, Custom
    FREELLMAPI_BASE_URL: "http://localhost:3001",
    FREELLMAPI_KEY: "freellmapi-f143e5e7552c9d68c3a89efbfef48b655e1e1d19a7518265",
    AI_PROVIDER: isLocal ? "freellmapi" as const : "ollama" as const,

    // Feature Flags
    ENABLE_SYNC: true,
    DEBUG_MODE: true
};